import ActivityStream from './container/ActivityStream'

export default ActivityStream
